var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('el-backtop',{attrs:{"bottom":40,"right":20,"visibility-height":280}},[_c('img',{staticStyle:{"width":"40px","height":"40px","border-radius":"50%"},attrs:{"src":require("./assets/img/focus/backtop.jpg"),"alt":"backtop"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }